module.exports = __webpack_public_path__ + "img/product_73.071f67f.webp";